import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { getRetirementList } from '@store/Finance/FixedAssets/Retirement/RetirementSlice';
// import { useTranslation } from 'react-i18next';

const useGetRetirementList = () => {
  const dispatch = useAppDispatch();
  // const { t, i18n } = useTranslation();

  useEffect(() => {
    // if (AssetsList?.length === 0) {
    dispatch(getRetirementList());
    // }
  }, []);
  const { RetirementList, loading, error } = useAppSelector(state => state.Retirement);

  // var OptionsAssets = Retirement?.map(({ id, name, name2 }) => ({
  //   value: id,
  //   label: `${i18n.language === 'en' ? name : name2}`,
  // }));

  return { RetirementList, loading, error };
};

export default useGetRetirementList;
